import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'searchFilter'
})
export class SearchFilterPipe implements PipeTransform {

  transform(data: any, searchTerm: string = ''): any {
    let search = searchTerm.trim()

    if (!data || !searchTerm || search == '') {
      return data
    } else {
      return data.filter((item) => {

        // if (item.name == '') {
        //   return data
        // }

        if (item.name != undefined) {

          return item.name.slice(0, searchTerm.length).toLowerCase() === searchTerm.toLocaleLowerCase()

        }

        if (!isNaN(item)) {

          return item.toString().slice(0, searchTerm.length) === searchTerm.toString()
        }




        // console.log(searchTerm)
        // console.log(item)



        // if (item.name.toLowerCase().indexOf(searchTerm.toLowerCase()) >= 0) {
        //   // console.log(searchTerm.length)
        //   // console.log(item.name.slice(0, searchTerm.length))
        //   // console.log("Search", searchTerm)
        //   // return item.name.toLowerCase().indexOf(searchTerm.toLowerCase()) !== -1
        //   return item.name.slice(0, searchTerm.length).toLowerCase() === searchTerm.toLocaleLowerCase()
        // }

      });
    }


  }

}
